<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent-fm2"><a id="page_vi"></a><a id="page_vii"></a>To Scottie</p>
<p class="noindent-fm3">For 9 October 1964</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Fm01.vue?63932bb7